import * as React from "react";
const SvgFiRrDisplaySlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-display-slash_svg__a)">
      <path
        fill="#062147"
        d="M24 14V8c0-2.757-2.243-5-5-5H5c-.187 0-.37.014-.552.034L1.708.294A.999.999 0 1 0 .292 1.706l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-3.467-3.467C22.396 18.271 24 16.327 24 14m-2 0c0 1.654-1.346 3-3 3h-.5c-.025 0-.047.013-.07.014L6.413 5H19c1.654 0 3 1.346 3 3zm-5.5 7a1 1 0 0 1-1 1H8a1 1 0 0 1 0-2h3v-1H5c-2.757 0-5-2.243-5-5V8c0-.42.053-.84.157-1.249a1 1 0 1 1 1.937.497A3 3 0 0 0 2 8v6c0 1.654 1.346 3 3 3h7a1 1 0 0 1 1 1v2h2.5a1 1 0 0 1 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-display-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDisplaySlash;
